import React, { useState, useEffect } from "react";
import '../Header/Header.css';

const OfflineStatus = ({ message = "No Internet, Your changes are not being saved" }) => {
    const [offline, setOffline] = useState(!window.navigator.onLine);

    useEffect(() => {
        const handleOfflineStatus = () => setOffline(!window.navigator.onLine);

        window.addEventListener("offline", handleOfflineStatus);
        window.addEventListener("online", handleOfflineStatus);

        return () => {
            window.removeEventListener("offline", handleOfflineStatus);
            window.removeEventListener("online", handleOfflineStatus);
        };
    }, []);

    if (!offline) return null;

    return (
        <div className="offlineStatus">
            <h5>{message}</h5>
        </div>
    );
};

export default OfflineStatus;
